
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as loginWs2S4x_45jM_t2WOuoeODzX_45F9bUBoxDNgn4jXvry9FDkMeta } from "/usr/src/app/pages/login.vue?macro=true";
import { default as offboardingvAMBWefriQ9S074gzUWf9gVPGDOifVboGG2NmY57MFgMeta } from "/usr/src/app/pages/settings/offboarding.vue?macro=true";
import { default as settingskX0Jub0vvRcsWAHjHJxle6Ey_17ybU0HEipUBC_45ZbxAMeta } from "/usr/src/app/pages/settings.vue?macro=true";
import { default as mexRmA3RGvIEZDl_45JJ6skXFmBaw_Nba08Boa6WtnYrT8IMeta } from "/usr/src/app/pages/users/me.vue?macro=true";
import { default as audit_45logvHmYHH1MHSMdOt_xDMdUmVIQ0klLcqe5mYmWNekjzvAMeta } from "/usr/src/app/pages/audit-log.vue?macro=true";
import { default as addzO2Jq50ZOy99PH9wbhdF1nnLy3wlbDi7SLAg97FLaukMeta } from "/usr/src/app/pages/roles/add.vue?macro=true";
import { default as addv_45Z4W_t_Mul7Q7TO1uasYqCI0wgFoy6EkcIcc2_Ne2sMeta } from "/usr/src/app/pages/users/add.vue?macro=true";
import { default as indexQzGRg0YwyJ7FUwEq9aztpsGw_45ULIh2MDHjj__5QTk8IMeta } from "/usr/src/app/pages/roles/index.vue?macro=true";
import { default as addrQ_45cK5TKC7N8uCrPdYhbTOz32CST0izeMumpdw33_o8Meta } from "/usr/src/app/pages/tenants/add.vue?macro=true";
import { default as indexPGtGK_SQG_6kiJTBTlWeNmchBZZoMZ5mN4ahtK_WDmoMeta } from "/usr/src/app/pages/users/index.vue?macro=true";
import { default as unauthorizeddbi24vYz7nbgXg8M13dnDSCkHMI2xZnESuHVQSG0FFsMeta } from "/usr/src/app/pages/unauthorized.vue?macro=true";
import { default as indexNXatU_hp6yVkwGQUBvHxb_rg1gRretHYtMj8K070hOUMeta } from "/usr/src/app/pages/clients/index.vue?macro=true";
import { default as indexj3rtsamIKl1qlb1ydsNiJmPgf4YtHo1ztkyG2ee0fBAMeta } from "/usr/src/app/pages/tenants/index.vue?macro=true";
import { default as addSFqfKDXVkMkjpAH0DspoUttLpZj5PG7i9sy3wl_LjgUMeta } from "/usr/src/app/pages/userGroups/add.vue?macro=true";
import { default as edithFIJxupYoDwUubJk0EPJGMEd8_CJwJ66_45LaJSjJV1tAMeta } from "/usr/src/app/pages/users/[id]/edit.vue?macro=true";
import { default as addgR9Cx_yPCkTzObqvx7I8qxUgFbiUVLXtkMSsRj0nOW4Meta } from "/usr/src/app/pages/clientGroups/add.vue?macro=true";
import { default as indexCd_45Dbi1U4QUoBmL9EClOkBJBJSn5_mXeACQ4fxzLDCQMeta } from "/usr/src/app/pages/userGroups/index.vue?macro=true";
import { default as editti2OzTPtDoaTYGa4wPxcFDfN5Uqk8_45KMzMav3SxapyIMeta } from "/usr/src/app/pages/tenants/[id]/edit.vue?macro=true";
import { default as indexV3btVYwl8FDCKUlDIVJLVGb4lMLusKWO6AxyzBS3FjAMeta } from "/usr/src/app/pages/configProfile/index.vue?macro=true";
import { default as editVnFKVq_lC_C5Uk0arYdI10UfIS0x1meQ8FprZVNN63oMeta } from "/usr/src/app/pages/roles/[roleid]/edit.vue?macro=true";
import { default as editNZhKSLIzXchIBso33MN_Xgbev8GrDw1ZfwxwCE3h7woMeta } from "/usr/src/app/pages/clients/[clientid]/edit.vue?macro=true";
import { default as indexYY21KB8QBtLTgwQeCVI8HC_wJGJRlrc5L_45ba67Iquf0Meta } from "/usr/src/app/pages/clients/[clientid]/index.vue?macro=true";
import { default as editGFSRCmC62m_TyY1saqkQDwS92MAaAcGgevcbKUw5xAEMeta } from "/usr/src/app/pages/userGroups/[groupid]/edit.vue?macro=true";
import { default as addKIal4w7KLRwuVMi_45R5Gb7kzI0GvwB1aKRzDqSb_t9ZsMeta } from "/usr/src/app/pages/clientGroups/[groupid]/add.vue?macro=true";
import { default as editzm7yCNYYFK1LNIEhGZPYK_45zEsfmDVgz7_45tdXWogkfvwMeta } from "/usr/src/app/pages/clientGroups/[groupid]/edit.vue?macro=true";
import { default as indexNOXHe1VLjobcy1vd2_cOToODjB6UPdrI9tDmuG54sVMMeta } from "/usr/src/app/pages/clientGroups/[groupid]/index.vue?macro=true";
import { default as editeVoTbFJ9mZ_b8IUBi0hhKIz6x6c6cC7AyEqKp3cScOoMeta } from "/usr/src/app/pages/configProfile/[profileid]/edit.vue?macro=true";
import { default as editEvC6r5tMTreKbGBS3h2whMdLd6nLmuWGxNm1BMjnfegMeta } from "/usr/src/app/pages/clientGroups/[groupid]/config/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginWs2S4x_45jM_t2WOuoeODzX_45F9bUBoxDNgn4jXvry9FDkMeta || {},
    component: () => import("/usr/src/app/pages/login.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/usr/src/app/pages/settings.vue"),
    children: [
  {
    name: "settings-offboarding",
    path: "offboarding",
    component: () => import("/usr/src/app/pages/settings/offboarding.vue")
  }
]
  },
  {
    name: "users-me",
    path: "/users/me",
    component: () => import("/usr/src/app/pages/users/me.vue")
  },
  {
    name: "audit-log",
    path: "/audit-log",
    component: () => import("/usr/src/app/pages/audit-log.vue")
  },
  {
    name: "roles-add",
    path: "/roles/add",
    component: () => import("/usr/src/app/pages/roles/add.vue")
  },
  {
    name: "users-add",
    path: "/users/add",
    component: () => import("/usr/src/app/pages/users/add.vue")
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("/usr/src/app/pages/roles/index.vue")
  },
  {
    name: "tenants-add",
    path: "/tenants/add",
    component: () => import("/usr/src/app/pages/tenants/add.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/usr/src/app/pages/users/index.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/usr/src/app/pages/unauthorized.vue")
  },
  {
    name: "clients",
    path: "/clients",
    component: () => import("/usr/src/app/pages/clients/index.vue")
  },
  {
    name: "tenants",
    path: "/tenants",
    component: () => import("/usr/src/app/pages/tenants/index.vue")
  },
  {
    name: "userGroups-add",
    path: "/userGroups/add",
    component: () => import("/usr/src/app/pages/userGroups/add.vue")
  },
  {
    name: "users-id-edit",
    path: "/users/:id()/edit",
    component: () => import("/usr/src/app/pages/users/[id]/edit.vue")
  },
  {
    name: "clientGroups-add",
    path: "/clientGroups/add",
    component: () => import("/usr/src/app/pages/clientGroups/add.vue")
  },
  {
    name: "userGroups",
    path: "/userGroups",
    component: () => import("/usr/src/app/pages/userGroups/index.vue")
  },
  {
    name: "tenants-id-edit",
    path: "/tenants/:id()/edit",
    component: () => import("/usr/src/app/pages/tenants/[id]/edit.vue")
  },
  {
    name: "configProfile",
    path: "/configProfile",
    component: () => import("/usr/src/app/pages/configProfile/index.vue")
  },
  {
    name: "roles-roleid-edit",
    path: "/roles/:roleid()/edit",
    component: () => import("/usr/src/app/pages/roles/[roleid]/edit.vue")
  },
  {
    name: "clients-clientid-edit",
    path: "/clients/:clientid()/edit",
    component: () => import("/usr/src/app/pages/clients/[clientid]/edit.vue")
  },
  {
    name: "clients-clientid",
    path: "/clients/:clientid()",
    component: () => import("/usr/src/app/pages/clients/[clientid]/index.vue")
  },
  {
    name: "userGroups-groupid-edit",
    path: "/userGroups/:groupid()/edit",
    component: () => import("/usr/src/app/pages/userGroups/[groupid]/edit.vue")
  },
  {
    name: "clientGroups-groupid-add",
    path: "/clientGroups/:groupid()/add",
    component: () => import("/usr/src/app/pages/clientGroups/[groupid]/add.vue")
  },
  {
    name: "clientGroups-groupid-edit",
    path: "/clientGroups/:groupid()/edit",
    component: () => import("/usr/src/app/pages/clientGroups/[groupid]/edit.vue")
  },
  {
    name: "clientGroups-groupid",
    path: "/clientGroups/:groupid()",
    component: () => import("/usr/src/app/pages/clientGroups/[groupid]/index.vue")
  },
  {
    name: "configProfile-profileid-edit",
    path: "/configProfile/:profileid()/edit",
    component: () => import("/usr/src/app/pages/configProfile/[profileid]/edit.vue")
  },
  {
    name: "clientGroups-groupid-config-edit",
    path: "/clientGroups/:groupid()/config/edit",
    meta: editEvC6r5tMTreKbGBS3h2whMdLd6nLmuWGxNm1BMjnfegMeta || {},
    component: () => import("/usr/src/app/pages/clientGroups/[groupid]/config/edit.vue")
  }
]